import { ReactNode } from 'react'
import { cn } from 'src/enviroment/lib/utils'

type BadgeVariant = 'neutral' | 'accent' | 'danger'

const VARIANT_STYLES: Record<BadgeVariant, string> = {
  neutral: 'bg-gray-700 text-gray-200',
  accent: 'bg-light-green-500/20 text-light-green-500',
  danger: 'bg-red-500/20 text-red-400',
}

interface BadgeProps {
  children: ReactNode
  variant?: BadgeVariant
  className?: string
}

const Badge = ({ children, variant = 'neutral', className }: BadgeProps) => (
  <span className={cn('rounded px-2 py-0.5 text-xs', VARIANT_STYLES[variant], className)}>{children}</span>
)

export default Badge
